import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { ChipClickable } from '../../../Chips';
import { startApplyBidTemplate } from '../../../../store/actions/bidTemplates';

const styles = theme => ({
  root: {
    minwidth: '150px',
    maxWidth: '400px',
  },
  description: {
    margin: theme.spacing.unit,
  }
});

const Template = ({ classes, bid, type, startApplyBidTemplate }) => {
  let label;
  let description;
  let action;
  switch (type) {
    case "simple":
      label = "Simple Estimate";
      description = "The best choice for a quick bid that doesn't need much detail or 'salesy' bits.";
      action = () => startApplyBidTemplate(bid.id, "estimate")
      break;
    case "recurring":
      label = "Recurring";
      description = "This type is for Maintenance or Recurring work; it records payment frequency, payment amount, duration of contract, and the budgeted hours for each work period.";
      action = () => startApplyBidTemplate(bid.id, "maintenance")
      break;
    case "full":
      label = "Full Proposal";
      description = "If you want to 'put your best foot forward', choose this type. It provides several areas to help you 'wow' your client, providing the highest probility of wining a bid.";
      action = () => startApplyBidTemplate(bid.id, "quote")
      break;
    default:

  }
  return(
    <div className={classes.root}>
      <ChipClickable
        label={label}
        handleClick={() => {
          action();
        }}/>
      <Typography className={classes.description}>
        {description}
      </Typography>
    </div>

  );
};

const mapStateToProps = (state) => {
  const bidId = state.adminState.bid.id;

  return({
    bid: state.bidsState.find( bid => bid.id === bidId ),
  });
};

const mapDispatchToProps = (dispatch) => ({
  startApplyBidTemplate: (bidId, type) => dispatch(startApplyBidTemplate(bidId, type)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Template);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Header/Template.jsx